import { IPGracefulRestartServicePort } from "./models/types";

export class ModifyGracefulRestartCommand {
  private service_ports: IPGracefulRestartServicePort[] = [];

  get payload() {
    return { service_ports: this.service_ports };
  }

  setForInstance(instanceId: string, state: boolean) {
    this.service_ports.push({
      subscription_instance_id: instanceId,
      graceful_restart: state,
    });
  }
}
